import { FunctionComponent } from "react";
import { TokenUserHelper } from "../services/token-user-service";
import { IFoundationProgram, IProgramClass } from "../models/foundationProgram";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ClassIcon from '@mui/icons-material/Class';
import { isSelected } from "../utilities/utils";

interface FPNavProps {
    program: IFoundationProgram;
    menuCollapsed: boolean;
    onExpandRequest: () => void;
}

const FPMenuNavigation: FunctionComponent<FPNavProps> = ({ program, menuCollapsed, onExpandRequest }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = React.useState(false);

    const isAnyClassSelected = program.classList.some(classDetails => {
        const classPath = `/FoundationProgram/${program.programName}/${classDetails.className}`;
        return isSelected(location.pathname, classPath);
    });

    React.useEffect(() => {
        setOpen(isAnyClassSelected && !menuCollapsed);
    }, [isAnyClassSelected, menuCollapsed]);

    const handleClassClick = (classDetails: IProgramClass) => {
        navigate('/FoundationProgram/' + program.programName + '/' + classDetails.className);
    };

    if (menuCollapsed) {
        return (
            <Tooltip title={program.programName} placement="right">
                <ListItemButton
                    onClick={onExpandRequest}
                    selected={isAnyClassSelected}
                    sx={{ justifyContent: 'center', px: 1 }}
                >
                    <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center' }}>
                        <MenuBookIcon />
                    </ListItemIcon>
                </ListItemButton>
            </Tooltip>
        );
    }

    return (
        <>
            <ListItemButton onClick={() => setOpen(!open)} selected={isAnyClassSelected}>
                <ListItemIcon>
                    <MenuBookIcon />
                </ListItemIcon>
                <ListItemText primary={program.programName} sx={{ fontSize: '0.875rem' }} disableTypography />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {program.classList.map((classDetails, index) => {
                        const classPath = `/FoundationProgram/${program.programName}/${classDetails.className}`;
                        const selected = isSelected(location.pathname, classPath);
                        return (
                            <ListItemButton
                                key={index}
                                sx={{ pl: 4 }}
                                onClick={() => handleClassClick(classDetails)}
                                selected={selected}
                            >
                                <ListItemIcon>
                                    <ClassIcon />
                                </ListItemIcon>
                                <ListItemText primary={classDetails.className} disableTypography sx={{ fontSize: '0.875rem' }} />
                            </ListItemButton>
                        );
                    })}
                </List>
            </Collapse>
        </>
    );
};
  
export const FoundationProgramMenu = ({ menuCollapsed = false, onExpandRequest = () => {} }: { menuCollapsed?: boolean; onExpandRequest?: () => void }) => {
    const foundationPrograms = TokenUserHelper.GetFoundationPrograms();
    return (
        <>
            {foundationPrograms.map((program, index) => (
                <FPMenuNavigation key={index} program={program} menuCollapsed={menuCollapsed} onExpandRequest={onExpandRequest} />
            ))}
        </>
    );
};